module.exports = __webpack_public_path__ + "static/media/weight.d3a418ef.svg";